import {UpcomingEvents} from "../../../components/dashboard-home/upcoming-events";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledDashboardHomeMainSectionWrapper} from "../../../styles/dashboard-home/dashboard-home";
import {Alert, Button, Col, Row, Space} from "antd";
import {DashboardMetrics} from "../../../components/dashboard-metrics";
import {useEffect, useState} from "react";
import {ProfileTemplateWidget} from "../../../components/widgets/template-widget";
import {TourWidget} from "../../../components/widgets/tour-widget";
import {AudioOutlined, PhoneOutlined} from "@ant-design/icons";
import {ProductIcon} from "../../../components/icons/icons";
import {GetStartedWidget} from "../../../components/widgets/get-started-widget";
import {NewAvailabilityWidget} from "../../../components/widgets/availability-widget";
import {DashboardHomeProducts} from "../../../components/dashboard-home/products";
import {ErrorBoundary} from "react-error-boundary";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";
import {GetCoachUpcomingCallsProvider} from "../../../context/upcoming-calls/coach";
import {DashboardHomeStoreSection} from "../../../components/dashboard-home/products/store-page";
// import DisplayNameSplashScreenModal from "../../../components/dashboard-home/display-name-splash-screen-modal";
const DashboardHomepage = () => {
  const [openCallCategoryModal, setOpenCallCategoryModal] = useState<boolean>(false);
  const [openOfferingCategoryModal, setOpenOfferingCategoryModal] =
    useState<boolean>(false);
  // const [openSplashScreenModal, setOpenSplashScreenModal] = useState<boolean>(false);

  // useEffect(() => {
  //   const hasSeenSplashScreen = localStorage.getItem("hasDisplayNameSeenSplashScreen");
  //   const boolhasSeenSplashScreen = !!hasSeenSplashScreen;
  //   setOpenSplashScreenModal(!boolhasSeenSplashScreen);
  // }, []);

  // const handleCloseSplashScreen = () => {
  //   setOpenSplashScreenModal(false);
  //   localStorage.setItem("hasDisplayNameSeenSplashScreen", "true");
  // };
  return (
    <div>
      <DashboardWrapper pageTitle="Get started with Coachli">
        <ErrorBoundary
          FallbackComponent={({error, resetErrorBoundary}) => (
            <div>
              <Alert
                message="Sorry, something went wrong."
                showIcon
                description={error.message}
                type="error"
                action={
                  <Button
                    onClick={() => {
                      resetErrorBoundary();
                    }}
                    size="small"
                    danger
                  >
                    Reset
                  </Button>
                }
              />
            </div>
          )}
        >
          <DashboardMetrics />
        </ErrorBoundary>
        <StyledDashboardHomeMainSectionWrapper>
          <Row gutter={[36, 30]}>
            <Col span={24} lg={{span: 16}}>
              <div className="dashboard-home-main-details-upcoming-content">
                <Space size={40} direction="vertical" style={{display: "flex"}}>
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <StyledPageHeader>Upcoming events</StyledPageHeader>
                        <div>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <GetCoachUpcomingCallsProvider>
                      <UpcomingEvents
                        setOpenCallCategoryModal={setOpenCallCategoryModal}
                        openCallCategoryModal={openCallCategoryModal}
                        openOfferingCategoryModal={openOfferingCategoryModal}
                        setOpenOfferingCategoryModal={setOpenOfferingCategoryModal}
                      />
                    </GetCoachUpcomingCallsProvider>
                  </ErrorBoundary>
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <StyledPageHeader>Products</StyledPageHeader>
                        <div>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    {/* <DashboardHomeProducts /> */}
                    <DashboardHomeStoreSection />
                  </ErrorBoundary>
                </Space>
              </div>
            </Col>
            <Col span={24} lg={{span: 8}}>
              <div className="dashboard-home-main-details-widget-content">
                <Space direction="vertical" size={40} style={{display: "flex"}}>
                  <GetStartedWidget
                    setOpenOfferingCategoryModal={setOpenOfferingCategoryModal}
                  />
                  <TourWidget
                    textInfo="Watch a video guide on how to start creating sessions for your customers"
                    buttons={[
                      <Button
                        href="https://www.loom.com/share/8fe4c16208e346eabc4aee4582222b1b?sid=732db50b-acd8-4d85-b5b6-3c64eb479302"
                        block
                        icon={<PhoneOutlined style={{fontSize: "1.6rem"}} />}
                        size="small"
                        target="_blank"
                      >
                        <span>1:1 sessions</span>
                      </Button>,
                      <Button
                        href="https://www.loom.com/share/e2a7c4deb24d4a258b3dbbe624215fe0?sid=7dbe1a15-308c-414a-b9a6-fc238c084168"
                        block
                        icon={<AudioOutlined style={{fontSize: "1.6rem"}} />}
                        size="small"
                        target="_blank"
                      >
                        <span>Live events</span>
                      </Button>,
                      <Button
                        href="https://www.loom.com/share/5067dcbcf7fe4a4a9ad460e0f5cb1e4a?sid=c7b737a1-a3b1-4fb4-8c99-cd84c542d9b6"
                        block
                        icon={<ProductIcon style={{fontSize: "1.6rem"}} />}
                        size="small"
                        target="_blank"
                      >
                        <span>Products</span>
                      </Button>,
                    ]}
                  />
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <NewAvailabilityWidget />
                  </ErrorBoundary>
                  <ProfileTemplateWidget />
                </Space>
              </div>
            </Col>
          </Row>
          {/* <DisplayNameSplashScreenModal
            visibleState={openSplashScreenModal}
            okFunc={() => {
              setOpenSplashScreenModal(false);
            }}
            cancelFunc={() => handleCloseSplashScreen()}
          ></DisplayNameSplashScreenModal> */}
        </StyledDashboardHomeMainSectionWrapper>
      </DashboardWrapper>
    </div>
  );
};

export {DashboardHomepage};
